import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { changePassword } from "../../../redux/authSlice";
const ChangePassword = () => {
  const dispatch = useDispatch();
  const { user, loading, error, message } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const handleChangePassword = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    // if (newPassword !== confirmPassword) {  // Check if new password and confirm password match
    //   toast.error("New password and confirm password do not match.");
    //   return;
    // }

    const data = {
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword
    };

    if (token) {
      dispatch(changePassword(data)).then((res) => {
        if (res.payload?.error) {
          toast.error(res.payload.error);
        } else {
          toast.success(res.payload.message);
        }
      }).catch((error) => toast.error(error));
    }

  }

  return (
    <Container className="mt-5">
      <Row>
        <Col md={12} className="text-center mb-4">
          <h2>Change Password</h2>
        </Col>
        <Col md={4}>
          <Card className="p-3 shadow-sm bg-white rounded">
            <Link to="/my/profile" className="text-decoration-none">Profile</Link>
            <Link to="/my/order" className="text-decoration-none">Order</Link>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="p-3 shadow-sm bg-white rounded">
            {/* {message && <Alert variant="info">{message}</Alert>} */}
            <Form onSubmit={handleChangePassword}>
              <Form.Group controlId="oldPassword">
                <Form.Label>Old Password</Form.Label>
                <Form.Control
                  type="password"
                  name="oldPassword"
                  placeholder="Enter old password"
                  value={formData.oldPassword}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="newPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="newPassword"
                  placeholder="Enter new password"
                  value={formData.newPassword}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* <Form.Group controlId="confirmPassword">
          <Form.Label>Confirm New Password</Form.Label>
          <Form.Control
            type="password"
            name="confirmPassword"
            placeholder="Confirm new password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </Form.Group> */}

              <Button variant="primary" type="submit" className="mt-3">
                Change Password
              </Button>
            </Form>
          </Card>
        </Col>

      </Row>


    </Container>
  );
};

export default ChangePassword;
